<div class="flex rounded-xl bg-white p-3 shadow-md">
  <span
    class="sticky top-4 bottom-4 col-span-2 rotate-180 self-center text-center font-medium"
    style="writing-mode: vertical-rl">
    Zuordung
  </span>

  <div class="mx-1.5 border-l border-gray-200"></div>

  <div class="w-full p-4">
    <div class="text-lg font-bold">
      Handelt es sich um einen neuen Auftrag oder eine Nachreichung/Widerspruch?
    </div>

    <button
      type="button"
      data-testid="existing-auftraege-neuer-auftrag-button"
      class="neuer-auftrag-button"
      [disabled]="!mandatoryFieldsAreFilled()"
      [pTooltip]="
        !mandatoryFieldsAreFilled()
          ? 'Bitte gibt zuerst die Schadennummer ein und wähle den Mandanten'
          : ''
      "
      [ngClass]="{ active: !selectedAuftrag() }"
      (click)="onClickNeuerAuftrag()">
      Neuer Auftrag
    </button>

    @if (!mandatoryFieldsAreFilled()) {
      <div class="warning">
        <img [ngSrc]="'assets/icons/circle-info-solid.svg'" width="18" height="18" alt="Warning" />
        <span>Bitte gibt zuerst die Schadennummer ein und wähle den Mandanten</span>
      </div>
    }

    <hr class="text-theme-light-gray mt-4 mb-4" />

    @if (existingAuftraege().length) {
      <div class="mb-2 font-bold">Folgende Aufträge sind zu der Schadennummer bekannt:</div>

      <p-carousel
        [ngClass]="{
          'carousel-with-buttons': existingAuftraege().length > 3,
          'carousel-with-two-items': existingAuftraege().length === 2,
        }"
        [value]="existingAuftraege()"
        [numVisible]="3"
        [numScroll]="3"
        [circular]="false"
        [showNavigators]="existingAuftraege().length > 3"
        [showIndicators]="false">
        <ng-template #item let-auftrag>
          <div
            class="p-1"
            [attr.data-testid]="'existing-auftraege-auftrag-' + auftrag.id"
            (keydown.enter)="onClickAuftrag(auftrag)"
            (click)="onClickAuftrag(auftrag)">
            <div class="auftrag-item" [ngClass]="{ active: selectedAuftrag() === auftrag }">
              <div class="mb-2 flex w-full flex-row items-center justify-between">
                <b>#{{ auftrag.index }}</b>
                @if (auftrag.latestStatus?.type === 'CANCELLED') {
                  <i>Storniert</i>
                }
                <button
                  type="button"
                  class="open-altsystem-auftrag-button"
                  [attr.data-testid]="'open-altsystem-auftrag-button-' + auftrag.id"
                  sharedCoreButton
                  variant="secondary"
                  (click)="onClickOpenAuftrag($event, auftrag)">
                  Zum Fall
                </button>
              </div>

              <div class="row">
                <span>Schadennummer:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="auftrag.schadenNummer">
                </b>
              </div>

              <div class="row">
                <span>Forderungsdatum:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="
                    auftrag.invoiceDate ? (auftrag.invoiceDate | localizedDate) : '-'
                  ">
                </b>
              </div>

              <div class="row">
                <span>Letzte Prüfung:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="
                    auftrag.lastSubmission ? (auftrag.lastSubmission | localizedDate) : '-'
                  ">
                </b>
              </div>

              <div class="row">
                <span>Forderungssumme:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="formatMoney(auftrag.claimAmount, true) ?? '-'">
                </b>
              </div>

              <div class="row">
                <span>Kürzungen:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="formatMoney(auftrag.reductionAmount, true) ?? '-'">
                </b>
              </div>

              <div class="row">
                <span>Nicht prüfbar:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="formatMoney(auftrag.nachfordernAmount, true) ?? '-'">
                </b>
              </div>

              <div class="row">
                <span>Betroffene*r:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="
                    (auftrag.claimant?.firstName ?? '') + ' ' + (auftrag.claimant?.lastName ?? '')
                  ">
                </b>
              </div>

              <div class="row">
                <span>Kostenträger:</span>
                <b
                  class="truncate whitespace-nowrap"
                  sharedCoreTooltipOnContentOverflow
                  [displayedValue]="auftrag.kst?.name ?? '-'">
                </b>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    } @else if (mandatoryFieldsAreFilled()) {
      <div class="font-bold">
        Es existieren keine Aufträge zu dieser Schadennummer, prüfe ggf. ob die Schadennummer anders
        angegeben wurde.
      </div>
    }
  </div>
</div>
